/**
 * user模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const ecert = {
  //得到ca证书
    info(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH_OPEN}/ca`, { params: params});
    },
    //变更当前人的ca证书
    change(params) {
      return axios.post(`${Vue.prototype.$base.API_PATH_OPEN}/ca/change`,params);
    },
    //验证当前登陆人的电子证书是否到期
    caexpire() {
      return axios.get(`${Vue.prototype.$base.API_PATH_OPEN}/caexpire`);
    }
}

export default ecert;



// WEBPACK FOOTER //
// ./src/api/ecert.js